(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/use-bingo-last-wins/assets/javascripts/use-bingo-last-wins.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/use-bingo-last-wins/assets/javascripts/use-bingo-last-wins.js');
"use strict";

const {
  useState
} = React;
const {
  fetchLastWins
} = svs.bingo_react.components.api;
const useInterval = svs.components.lbUtils.useInterval;
const useBingoLastWins = () => {
  const [lastWins, setLastWins] = useState([]);
  useInterval(() => {
    const fetchWins = async () => {
      try {
        const result = await fetchLastWins();
        setLastWins(result);
      } catch (e) {
        setLastWins([]);
      }
    };
    fetchWins();
  }, 5000, true);
  return {
    lastWins
  };
};
setGlobal('svs.bingo_react.components.useBingoLastWins', useBingoLastWins);

 })(window);